import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=4f5f3886"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutInfoBar: require('/opt/build/repo/components/layout/InfoBar.vue').default,LayoutHeader: require('/opt/build/repo/components/layout/Header.vue').default,LayoutFooter: require('/opt/build/repo/components/layout/Footer.vue').default,EshopCartDrawer: require('/opt/build/repo/node_modules/@evince/eshop/lib/packages/CartDrawer.vue').default,ScCookieBar: require('/opt/build/repo/node_modules/@evince/site/lib/packages/CookieBar.vue').default})
